import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import Select from 'react-select';

import { WELLNESS } from './../../../assets/Domains';
import utils from './../../../lib/utils';
import PhoneInput from './../../FormComponents/PhoneInput';

import Phone from './../img/phone@2x.png';
import Calendar from './../img/calendar@2x.png';
import Page from './../img/page@2x.png';
import './index.scss';

export default class AuthSignUp extends React.Component {
  constructor() {
    super();

    // Get email from URL and pre-populate state
    const email = utils.getURLParameterByName('email');

    this.state = {
      firstName: '',
      lastName: '',
      email: email || '',
      password: '',
      phone: '',
      business_name: '',
      business_website: '',
      location_count: 1,
      domain: utils.getURLParameterByName('domain') || WELLNESS,
      hasError: false,
      isPasswordVisible: false,
      isEmailInvalid: false,
      isFirstNameBlank: false,
      isLastNameBlank: false,
      isPassowrdMinLengthFail: false,
      isDomainBlank: false,
    };

    this.onSignupFormSubmit = this.onSignupFormSubmit.bind(this);
    this.onFirstNameChange = this.onFirstNameChange.bind(this);
    this.onLastNameChange = this.onLastNameChange.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onShowPasswordClick = this.onShowPasswordClick.bind(this);
    this.onDomainChange = this.onDomainChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.props.getDomains();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.auth.isRegisterUserFail === true &&
      !this.props.auth.isRegisterUserFail
    ) {
      this.setState({
        hasError: true,
      });
    }
  }

  onFirstNameChange(event) {
    this.setState(
      {
        firstName: event.target.value,
      },
      this.resetValidation,
    );
  }

  onLastNameChange(event) {
    this.setState(
      {
        lastName: event.target.value,
      },
      this.resetValidation,
    );
  }

  onEmailChange(event) {
    this.setState(
      {
        email: event.target.value,
      },
      this.resetValidation,
    );
  }

  onPasswordChange(event) {
    this.setState(
      {
        password: event.target.value,
      },
      this.resetValidation,
    );
  }

  onShowPasswordClick(event) {
    event.preventDefault();

    this.setState({
      isPasswordVisible: !this.state.isPasswordVisible,
    });
  }

  onDomainChange(item) {
    this.setState({
      domain: item.domainId,
    });
  }

  onSignupFormSubmit(event) {
    event.preventDefault();

    if (this.validate()) {
      this.props.postUser({
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        password: this.state.password,
        phone: this.state.phone,
        business_name: this.state.business_name,
        business_website: this.state.business_website,
        location_count: this.state.location_count,
        domain_id: this.state.domain,
      });
    }
  }

  handleInputChange(event) {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      this.resetValidation,
    );
  }

  validate() {
    const isValid =
      this.state.firstName &&
      this.state.lastName &&
      this.state.email &&
      this.state.password &&
      utils.isValidEmail(this.state.email) &&
      this.state.password.length >= 8 &&
      this.state.phone &&
      utils.isValidPhone(this.state.phone) &&
      this.state.business_name &&
      utils.isValidURL(this.state.business_website) &&
      utils.isNumber(this.state.location_count) &&
      this.state.domain;

    this.setState({
      isEmailInvalid: !utils.isValidEmail(this.state.email),
      isFirstNameBlank: !this.state.firstName.trim(),
      isLastNameBlank: !this.state.lastName.trim(),
      isPasswordBlank: !this.state.password,
      isEmailBlank: !this.state.email,
      isPassowrdMinLengthFail: this.state.password.length < 8,
      isPhoneBlank: !this.state.phone,
      isPhoneInvalid: !utils.isValidPhone(this.state.phone),
      isBusinessNameBlank: !this.state.business_name,
      isBusinessWebsiteInvalid: !utils.isValidURL(this.state.business_website),
      isLocationCountInvalid: !utils.isNumber(this.state.location_count),
      isDomainBlank: !this.state.domain,
    });

    return isValid;
  }

  resetValidation() {
    this.setState({
      isEmailInvalid: false,
      isFirstNameBlank: false,
      isLastNameBlank: false,
      isPasswordBlank: false,
      isEmailBlank: false,
      isPassowrdMinLengthFail: false,
      isDomainBlank: false,
    });
  }

  render() {
    let errorMessage = '';
    let showErrorMessage = false;

    if (this.state.hasError) {
      errorMessage =
        'An account already exists with this email ID. Please Sign In to continue';
      showErrorMessage = true;
    } else if (this.state.isFirstNameBlank) {
      errorMessage = 'First Name cannot be blank';
      showErrorMessage = true;
    } else if (this.state.isLastNameBlank) {
      errorMessage = 'Last Name cannot be blank';
      showErrorMessage = true;
    } else if (this.state.isEmailBlank) {
      errorMessage = 'Email cannot be blank';
      showErrorMessage = true;
    } else if (this.state.isPasswordBlank) {
      errorMessage = 'Password cannot be blank';
      showErrorMessage = true;
    } else if (this.state.isEmailInvalid) {
      errorMessage = 'Please enter a valid email id';
      showErrorMessage = true;
    } else if (this.state.isPassowrdMinLengthFail) {
      errorMessage = 'Password should be at least 8 characters';
      showErrorMessage = true;
    } else if (this.state.isDomainBlank) {
      errorMessage = 'Please select a domain';
      showErrorMessage = true;
    }

    return (
      <div className="auth-signup">
        <div className="auth-signup__left">
          <h3>Get started today!</h3>
          <ul className="auth-signup__left__features">
            <li>
              <img
                className="svg"
                src="https://image.flaticon.com/icons/svg/1432/1432745.svg"
                width="48"
                alt=""
              />
              24/7 Receptionist
            </li>
            <li>
              <img
                className="svg"
                src="https://image.flaticon.com/icons/svg/481/481313.svg"
                width="48"
                alt=""
              />
              Never miss another call
            </li>
            <li>
              <img
                className="svg"
                src="https://image.flaticon.com/icons/svg/1077/1077976.svg"
                width="48"
                alt=""
              />
              30% revenue increase
            </li>
          </ul>
        </div>
        <div className="auth-signup__right">
          <div className="auth-signup__container">
            <h4>Let’s create your account</h4>
            <div className="auth-signup__container__work-flow">
              <p className="auth-signup__container__work-flow__text">&nbsp;</p>
              <div className="work-flow">
                <div className="work-flow__data">
                  <img src={Calendar} alt="presentation" width="34" />
                  <span className="work-flow__data__heading">
                    Connect your scheduling software
                  </span>
                  <p className="work-flow__data__text">
                    Authorize TrueLark to access staff schedules and services
                    information
                  </p>
                </div>
                <div className="work-flow__data">
                  <img src={Phone} alt="presentation" width="41" />
                  <span className="work-flow__data__heading">
                    Connect your business phone
                  </span>
                  <p className="work-flow__data__text">
                    Forward your missed calls to a unique text-only number that
                    we assign to your business
                  </p>
                </div>
                <div className="work-flow__data">
                  <img src={Page} alt="presentation" width="36" />
                  <span className="work-flow__data__heading">
                    Get started today!
                  </span>
                  <p className="work-flow__data__text">
                    No commitments or long-term contracts
                  </p>
                </div>
              </div>
            </div>
            <div className="auth-signup__container__form">
              {showErrorMessage ? (
                <div className="message message--error">{errorMessage}</div>
              ) : (
                undefined
              )}
              <form onSubmit={this.onSignupFormSubmit}>
                <div className="form-group">
                  <label htmlFor="firstName">First Name</label>
                  <input
                    type="text"
                    name="firstName"
                    value={this.state.firstName}
                    onChange={this.onFirstNameChange}
                    className={classnames({
                      'has-error': this.state.isFirstNameBlank,
                    })}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    value={this.state.lastName}
                    onChange={this.onLastNameChange}
                    className={classnames({
                      'has-error': this.state.isLastNameBlank,
                    })}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Business Email (login)</label>
                  <input
                    type="text"
                    name="email"
                    placeholder="you@example.com"
                    value={this.state.email}
                    onChange={this.onEmailChange}
                    className={classnames({
                      'has-error':
                        this.state.isEmailBlank || this.state.isEmailInvalid,
                    })}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <div className="password-field">
                    <input
                      type={this.state.isPasswordVisible ? 'text' : 'password'}
                      name="password"
                      value={this.state.password}
                      onChange={this.onPasswordChange}
                      className={classnames({
                        'has-error':
                          this.state.isPasswordBlank ||
                          this.state.isPassowrdMinLengthFail,
                      })}
                    />
                    <a
                      href=""
                      onClick={this.onShowPasswordClick}
                      className="show-password"
                    >
                      {this.state.isPasswordVisible ? 'Hide' : 'Show'}
                    </a>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <PhoneInput
                    placeholder=""
                    name="phone"
                    value={this.state.phone}
                    onChange={this.handleInputChange}
                    className={classnames({
                      'has-error':
                        this.state.isPhoneBlank || this.state.isPhoneInvalid,
                    })}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="business_name">Business Name</label>
                  <input
                    type="text"
                    name="business_name"
                    placeholder=""
                    value={this.state.business_name}
                    onChange={this.handleInputChange}
                    className={classnames({
                      'has-error':
                        this.state.isBusinessNameBlank ||
                        this.state.isBusinessNameInvalid,
                    })}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="business_website">Business Website</label>
                  <input
                    type="text"
                    name="business_website"
                    placeholder=""
                    value={this.state.business_website}
                    onChange={this.handleInputChange}
                    className={classnames({
                      'has-error': this.state.isBusinessWebsiteInvalid,
                    })}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="location_count">Number of locations</label>
                  <input
                    type="text"
                    name="location_count"
                    placeholder="2"
                    value={this.state.location_count}
                    onChange={this.handleInputChange}
                    className={classnames({
                      'has-error': this.state.isLocationCountInvalid,
                    })}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="domain">Market</label>
                  <Select
                    getOptionLabel={(option) => option.domainName}
                    getOptionValue={(option) => option.domainId}
                    value={this.props.domain.list.filter(
                      (option) => option.domainId === this.state.domain,
                    )}
                    options={this.props.domain.list}
                    onChange={this.onDomainChange}
                  />
                </div>

                <div className="form-group" />

                <div className="form-group">
                  <div className="auth-signup__container__form__login">
                    <p>
                      Already have a TrueLark account?&nbsp;
                      <NavLink to="/login">Sign In</NavLink>
                    </p>
                  </div>
                </div>
                <div className="form-group">
                  <button
                    type="submit"
                    className="btn btn--primary btn--lg"
                    disabled={this.props.auth.isRegistering}
                  >
                    Create Account
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AuthSignUp.defaultProps = {
  postUser: () => {},
  getDomains: () => {},
  auth: {
    isRegistering: false,
    isRegisterUserFail: false,
  },
  domain: {
    list: [],
  },
};

AuthSignUp.propTypes = {
  postUser: PropTypes.func,
  getDomains: PropTypes.func,
  auth: PropTypes.shape({
    isRegistering: PropTypes.bool,
    isRegisterUserFail: PropTypes.bool,
  }),
  domain: PropTypes.shape({
    list: PropTypes.array,
  }),
};
